import React from "react";
import "./ProgressIndicator.scss";
import CircularProgress from "@material-ui/core/CircularProgress";

const ProgressIndicator = ({ isLoading, progress, message }) => {
  if (!isLoading) return null;

  const showProgress = progress !== undefined && progress > 0;
  const progressValue = showProgress ? progress : 0;

  return (
    <div className="progress-indicator">
      <div className="progress-content">
        <CircularProgress
          size={28}
          variant={showProgress ? "determinate" : "indeterminate"}
          value={progressValue}
          style={{ color: "#223C7D" }}
        />
        <div className="progress-text">
          <span className="progress-message">{message || "Loading..."}</span>
          {showProgress && (
            <span className="progress-percentage">
              {Math.round(progressValue)}%
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressIndicator;
